import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import StateSelector from '../TabelaRSL/StateSelector';
import './EmailManagement.css';

const EmailManagement = () => {
  const [selectedState, setSelectedState] = useState(null);
  const navigate = useNavigate();

  const handleStateSelect = (state) => {
    setSelectedState(state);
    
    // Navigate to state-specific email management
    if (state === 'BA') {
      navigate('/admin/email/ba');
    } else {
      // For other states, show coming soon message
    }
  };

  return (
    <div className="email-management-container">
      <div className="email-management-header">
        <h1>Enviar Emails por Estado</h1>
        <p className="header-subtitle">
          Selecione um estado para gerenciar o envio de emails para destinatários com precatórios
        </p>
        <button 
          className="analytics-link-button"
          onClick={() => navigate('/admin/email/analytics')}
          style={{
            marginTop: '1rem',
            padding: '0.75rem 1.5rem',
            backgroundColor: '#4299e1',
            color: 'white',
            border: 'none',
            borderRadius: '6px',
            fontSize: '1rem',
            cursor: 'pointer',
            display: 'inline-flex',
            alignItems: 'center',
            gap: '0.5rem'
          }}
        >
          📊 Ver Analytics de Campanhas
        </button>
      </div>
      
      {!selectedState ? (
        <StateSelector onStateSelect={handleStateSelect} />
      ) : (
        <div className="selected-state-content">
          <button 
            className="back-button"
            onClick={() => setSelectedState(null)}
          >
            ← Voltar para seleção de estado
          </button>
          <h2>Estado selecionado: {selectedState}</h2>
          
          {selectedState !== 'BA' && (
            <div className="coming-soon-message">
              <div className="icon">📧</div>
              <h3>Funcionalidade em desenvolvimento</h3>
              <p>
                O sistema de envio de emails para {selectedState} estará disponível em breve.
              </p>
              <p className="info-text">
                Por enquanto, apenas o estado da Bahia (BA) está com o sistema de emails ativo.
              </p>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default EmailManagement;